<style lang="scss" scoped>
.outer-container {
  width: 100% !important;
  position: relative;
  overflow-x: hidden;

  ul {
    list-style: none;
    padding: 0;
  }

  .blocker {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 999;

    &.error {
      background-color: rgba(0, 0, 0, 0.5) !important;
      cursor: no-drop;
    }

    &.loading::after {
      background: linear-gradient(90deg,transparent,hsla(0,0%,100%,.3),transparent);
      -webkit-animation: loading 1.5s infinite;
      animation: loading 1.5s infinite;
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      transform: translateX(-100%);
      z-index: 1;
      cursor: progress;
  }
  }

  .inner-container {
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-left: 8px !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
    overflow-y: auto;

    &.left {
      background-color: rgba(0, 0, 0, 0.2);
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-right: 0;
      margin-left: 12px !important;
    }
    &.right {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      margin-left: 0 !important;
      margin-right: 12px !important;
      border-left: 0;
    }

    a {
      color: inherit;
      &.selected {
        font-weight: 700 !important;
        color: #1976d2 !important;
      }
    }
  }
}
</style>

<template>
  <div class="outer-container">
    <div
      v-show="error || loading"
      class="blocker"
      :class="{
        'loading': loading,
        'error': error,
      }"
    />
    <v-row>
      <v-col
        :class="`inner-container left ${resolveElevation()}`"
        :style="{ 'height': `${height}px` }"
      >
        <ul class="td-list">
          <li
            v-for="(item, idx) in options"
            :key="idx"
          >
            <a
              :class="{ 'selected': value.includes(item) }"
              @click="() => select(item)"
            >
              {{ item }}
            </a>
          </li>
        </ul>
      </v-col>
      <v-col
        :class="`inner-container right ${resolveElevation()}`"
        :style="{ 'height': `${height}px` }"
      >
        <ul class="td-list">
          <li
            v-for="item in value"
            :key="item"
          >
            <v-btn x-small color="primary" @click="() => select(item)">
              <v-icon class="caption mr-2">mdi-close</v-icon>
              {{ item }}
            </v-btn>
          </li>
        </ul>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'AnchorListSelect',
  props: {
    height: {
      type: [String, Number],
      default: '300',
    },
    loading: Boolean,
    error: Boolean,
    options: {
      type: Array,
      default: () => ([]),
    },
    elevation: [String, Number],
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    select(item) {
      const index = this.value.indexOf(item);
      if (index === -1) {
        this.value.push(item);
      } else {
        this.value.splice(index, 1);
      }
    },
    resolveElevation() {
      if (this.elevation) {
        return `elevation-${this.elevation}`;
      }
      return '';
    },
  },
  watch: {
    value(val) {
      this.$emit('input', val);
    },
  },
};
</script>
